import { Box, Grid } from "@mui/material";
import { useState } from "react";
import { FormProvider, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RoundedButton } from "../../../../common/components/styled/styled";
import {
  BULK_SALARY_INCREASE_DEFAULT_FILTERS,
  BULK_SALARY_INCREASE_FILTER_NAMES,
  BULK_SALARY_INCREASE_TARGETS,
} from "../constants";
import { BulkSalaryIncreaseFilterValues } from "../types";
import BulkSalaryIncreaseAdditionalFilters from "./BulkSalaryIncreaseAdditionalFilters";
import BulkSalaryIncreaseBasicFilters from "./BulkSalaryIncreaseBasicFilters";
import BulkSalaryIncreaseTesTablesReferenceSection from "./BulkSalaryIncreaseTesTablesReferenceSection";
import BulkSalaryIncreaseTesTablesSalaryDate from "./BulkSalaryIncreaseTesTablesSalaryDate";
import KtaIncreaseConfig from "./KtaIncreaseConfig";
import SalaryIncreaseConfig from "./SalaryIncreaseConfig";

interface Props {
  // filters: SearchFilter[];
  fetchData: (filters: BulkSalaryIncreaseFilterValues) => void;
  handleMenuToggle: () => void;
}

const BulkSalaryIncreaseFilters = ({
  // filters,
  fetchData,
  handleMenuToggle,
}: Props) => {
  const { t } = useTranslation();

  const [expands, setExpands] = useState<Record<string, boolean>>({
    additionalFilters: true,
    increaseConfig: false,
  });

  const methods = useFormContext<BulkSalaryIncreaseFilterValues>();

  // console.log("filters", methods.watch());

  // console.log("watch", methods.watch("isIncreaseApplied"), methods.watch());
  const {
    handleSubmit,
    formState: { isValid },
  } = methods;

    const {watch} =
        useFormContext<BulkSalaryIncreaseFilterValues>();

  const components = methods.watch("salaryComponents")
  //console.log("COMPONENTS", components);
  const sendFilters = (filters: BulkSalaryIncreaseFilterValues) => {
    handleMenuToggle();
    fetchData(filters);
  };

  const target = watch(BULK_SALARY_INCREASE_FILTER_NAMES.TARGET);
  const getFilter = (name: BULK_SALARY_INCREASE_FILTER_NAMES) => {
    return BULK_SALARY_INCREASE_DEFAULT_FILTERS.find(
      (filter) => filter.name === name,
    );
  };

  const handleExpands = (salaryComponent: string) => {
    setExpands({ ...expands, [salaryComponent]: !expands[salaryComponent] });
  };

  const addExpands = (salaryComponent: string, open: boolean = false) => {
    setExpands((prev) => ({...prev, [salaryComponent]: open}));
  };

  const saveDisabled = !isValid;// || !isDirty;
  // console.log("xERRORS", errors, isValid, isDirty, target);
  const isKta = target === BULK_SALARY_INCREASE_TARGETS.KTA;
  const isTesTables = target === BULK_SALARY_INCREASE_TARGETS.TES_TABLES;
  return (
    <Box id="bulk-salary-increase-filters" padding="0px 6px 6px 6px">
      <Grid container columnSpacing={2} rowSpacing={1}>
        <FormProvider {...methods}>
          <BulkSalaryIncreaseBasicFilters getFilter={getFilter} components={!isKta && !isTesTables ? components : []}/>
          {isTesTables && <BulkSalaryIncreaseTesTablesSalaryDate />}
          {isTesTables && <BulkSalaryIncreaseTesTablesReferenceSection />}
          {!isKta && !isTesTables && <BulkSalaryIncreaseAdditionalFilters
            handleExpands={handleExpands}
            expands={expands.additionalFilters}
            getFilter={getFilter}
          />}
          {isKta && <KtaIncreaseConfig
                handleExpands={handleExpands}
                addExpands={addExpands}
                expands={expands}
            ></KtaIncreaseConfig>
            }
          {!isKta && !isTesTables &&
                <SalaryIncreaseConfig
                    handleExpands={handleExpands}
                    addExpands={addExpands}
                    expands={expands}
                />
            }
        </FormProvider>
        <Grid item xs={12} mt={2}>
          <Box display="flex" justifyContent="start">
            <RoundedButton
              disabled={saveDisabled}
              variant="contained"
              onClick={handleSubmit(sendFilters)}
            >
              {t("settings:bulkSalaryIncrease.fetchButtonText")}
            </RoundedButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BulkSalaryIncreaseFilters;
